import { GalleryImage } from "@/components/index/gallery/galleryData";

// Mock gallery images data with enhanced player photos for a photo wall
export const mockGalleryImages: GalleryImage[] = [
  {
    id: "1",
    src: "/photo/IMG_7273.webp",
    alt: "Players solving mystery clues together",
    title: "Detective Team",
    description: "Friends working together to solve the Victorian mystery",
    category: "players",
    location: "London Mystery Club"
  },
  {
    id: "2",
    src: "/photo/IMG_5402.webp",
    alt: "Group discussion during mystery game",
    title: "Clue Analysis",
    description: "Players analyzing evidence in the library scene",
    category: "gameplay",
    location: "Boston Game Cafe"
  },
  {
    id: "3",
    src: "/photo/IMG_6839.webp",
    alt: "Friends celebrating solving the mystery",
    title: "Mystery Solved!",
    description: "The winning team after cracking the case",
    category: "celebration",
    location: "New York Game Night"
  },
  {
    id: "4",
    src: "/photo/IMG_6853.webp",
    alt: "Team strategy session",
    title: "Strategy Session",
    description: "Players planning their investigation approach",
    category: "gameplay",
    location: "Strategy Room"
  },
  {
    id: "5",
    src: "/photo/IMG_8051.webp",
    alt: "Players in character costumes",
    title: "In Character",
    description: "Fully immersed players in period costumes",
    category: "costumes",
    location: "Costume Party"
  },
  {
    id: "6",
    src: "/photo/IMG_5404.webp",
    alt: "Evening mystery game session",
    title: "Night Mysteries",
    description: "Atmospheric evening game session",
    category: "atmosphere",
    location: "The Dark Mansion"
  },
  {
    id: "7",
    src: "/photo/IMG_5405.webp",
    alt: "Players examining mystery props",
    title: "Examining Evidence",
    description: "Detailed inspection of the case materials",
    category: "gameplay",
    location: "Detective Office"
  },
  {
    id: "8",
    src: "/photo/IMG_6784.webp",
    alt: "Themed restaurant mystery night",
    title: "Dinner Mystery",
    description: "Combining fine dining with mystery solving",
    category: "venues",
    location: "Mystery Diner"
  },
  {
    id: "9",
    src: "/photo/IMG_6800.webp",
    alt: "Friends laughing during game night",
    title: "Game Night Fun",
    description: "The joy of mystery gaming with friends",
    category: "social",
    location: "Home Game Night"
  },
  {
    id: "10",
    src: "/photo/IMG_5367.webp",
    alt: "Beach themed mystery game",
    title: "Beach Mystery",
    description: "Solving crimes in a tropical setting",
    category: "themed",
    location: "Coastal Game Club"
  },
  {
    id: "11",
    src: "/photo/IMG_5368.webp",
    alt: "International player group",
    title: "Global Players",
    description: "Mystery enthusiasts from around the world",
    category: "community",
    location: "International Convention"
  },
  {
    id: "12",
    src: "/photo/IMG_5369.webp",
    alt: "Virtual mystery game session",
    title: "Virtual Game Night",
    description: "Online mystery solving with remote friends",
    category: "online",
    location: "Virtual Room"
  },
  {
    id: "13",
    src: "/photo/IMG_5396.webp",
    alt: "Enthusiastic mystery game participant",
    title: "Game Excitement",
    description: "The thrill of finding a crucial clue",
    category: "emotions",
    location: "City Game Center"
  },
  {
    id: "14",
    src: "/photo/IMG_5399.webp",
    alt: "Players in steampunk costumes",
    title: "Steampunk Mystery",
    description: "Alternate history detective work",
    category: "themed",
    location: "Steampunk Convention"
  },
  {
    id: "15",
    src: "/photo/IMG_5400.webp",
    alt: "Family playing mystery games",
    title: "Family Case",
    description: "All-ages mystery solving adventure",
    category: "family",
    location: "Family Game Center"
  },
  {
    id: "16",
    src: "/photo/IMG_2053.webp",
    alt: "Mystery game facilitator explaining rules",
    title: "Game Master",
    description: "Professional game runner setting the scene",
    category: "staff",
    location: "Mystery Studio"
  },
  {
    id: "17",
    src: "/photo/IMG_2054.webp",
    alt: "Corporate team building mystery event",
    title: "Corporate Mystery",
    description: "Team-building through collaborative detective work",
    category: "corporate",
    location: "Office Event Space"
  },
  {
    id: "18",
    src: "/photo/IMG_2056.webp",
    alt: "Players in Paris-themed mystery",
    title: "Parisian Mystery",
    description: "Solving mysteries in a French setting",
    category: "international",
    location: "Le Mystère Café"
  },
  {
    id: "19",
    src: "/photo/IMG_2057.webp",
    alt: "Antique mystery artifacts",
    title: "Historical Evidence",
    description: "Ancient clues from the past",
    category: "artifacts",
    location: "Museum of Mysteries"
  },
  {
    id: "20",
    src: "/photo/IMG_4535.webp",
    alt: "Interactive mystery wall",
    title: "Wall of Clues",
    description: "Interconnected evidence display",
    category: "props",
    location: "Detective Headquarters"
  }
];
